<template>
    <section class="container">
      <div class="route">
        {{$locales.condicionesespeciales.condicionesespeciales}} > {{$locales.condicionesespeciales.cuentaabono}}
      </div>
      <div class="sidebar">
        <span class="principal">{{$locales.condicionesespeciales.condicionesespeciales}}</span>
        <ul>
          <li @click="refresh">
            <router-link to="/onesaitConfirmingProviders/condiciones-especiales/cuenta-abono"  class="link-active">
              {{$locales.condicionesespeciales.cuentaabono}}
            </router-link>
          </li>
          <li>
            <router-link to="/onesaitConfirmingProviders/condiciones-especiales/anticipo-automatico" class="link">
              {{$locales.condicionesespeciales.anticipoautomatico}}
            </router-link>
          </li>
        </ul>
      </div>
      <div class="window">
         <div class="mensajeConfirmacion" v-if="confirmacion=='OK'">
          <p>check_circle</p>
        <h3>Operación realizada con éxito</h3>
       </div>
       <div class="mensajeError" v-else-if="confirmacion=='KO'">
          <p>cancel</p>
          <h3>{{mensajeError}}</h3>
       </div>
        <h1>{{$locales.condicionesespeciales.cuentaabono}}</h1>
        <div class="form-group">
          <form class="window-form" @submit.prevent="aceptarCuentaUnica">
            <md-list id="cuentaUnica">
              <md-list-item md-expand>
                <span class="md-list-item-text">Cuenta única abono anticipos</span>
                <md-list slot="md-expand">
                  <label for="cuenta1">Cuenta</label>                  
                  <input class = "inputComponent" type="text" id="nombre" name="nombre" autocomplete="off" v-model="model.account"/>  
                  <input class="btnPrimary noMarginTop" type="submit" value="Aceptar" v-if=beforeSubmit>               
                </md-list>
              </md-list-item>
            </md-list>
          </form>

          <form class="window-form" @submit.prevent="aceptarCuentasDeudores">
            <md-list id="cuentasDeudores">
              <md-list-item md-expand>
                <span class="md-list-item-text">Asociar cuentas por deudores</span>
                <md-list slot="md-expand">
                  <div id="deudores-list" v-if="deudores && deudores.length >= 1">
                    <div class="row" v-for="(registro,index) in deudores" :key="index">
                      <span id="nombreDeudor">{{registro.name}} - {{registro.contractId}}</span>
                      <div id="columnaCuentas">
                        <input class = "inputComponent" type="text" id="nombre + index" name="nombre + index" v-model="registro.relatedAccount" autocomplete="off"/> 
                      </div>
                    </div>
                  </div>
                  <div v-else-if="deudores && deudores.length < 1">No hay deudores para mostrar</div>
                  <input class="btnPrimary noMarginTop" type="submit" value="Aceptar" v-if=beforeSubmit2 :disabled="isDeudorDisabled">
                </md-list>
              </md-list-item>
            </md-list>
          </form>
        </div>
        <div v-if=datosFirma>
          <SignatureComponent :params="params" :datosFirma="datosFirma" :llamada="llamada" @aceptar="callBackAceptar" @cancelar="callBackCancelar"></SignatureComponent>
        </div> 
      </div>
    </section>
</template>

<script>
import PaymentAccount from '../models/PaymentAccount';
export default {
    name : 'PaymentAccountComponent',
    data(){
      return{
        active: true,
        active2: false,
        submitted: false,
        deudores:[],
        mensajeError: null,
        datosFirma: null,
        confirmacion: null,
        llamada: null,
        resultado: null,
        params : null,
        params2 : null,
        resultado2: null,
        beforeSubmit: true,
        beforeSubmit2: true,
        model : new PaymentAccount(),
        accounts : new Object
      }
    },

     created: function(){
      const ventana=this; //llamada a /api-confirming/confirming/supplier
      const baseURI = '/api-confirming/confirming/supplierDetail';
      let loader = this.$loading.show();
      this.$http.get(baseURI)
      .then((result) => {
        this.resultado=result;
        if(result.data.data.account.formats.length != 0) {
          this.model.account = result.data.data.account.formats[1].value;
        }
        loader.hide();
      })
      .catch(error => {
        if(error.response){
          var codError = null; 
          var descError = null;
          if(error.response.status != 200) {
            if(error.response.data.result.errors[0].errorCode == "096H") {
              this.datosFirma = error.response.data.result.errors[0].info;
              this.beforeSubmit = false;
            } else {
              codError = error.response.data.result.errors[0].errorCode;
              descError = error.response.data.result.errors[0].errorDescription;
              this.mensajeError = codError + " - " + descError;
              this.confirmacion = "KO";
              loader.hide();
              window.scroll({
                top: 0,
                left: 0,
                behavior: 'smooth'
              });
            }
          }
        }else{ //si no, por defecto
          ventana.mensajeError='Algo ha ido mal, asegúrate que has introducido correctamente los datos';
          ventana.confirmacion='KO';
        }
      })
      //llamada a /api-confirming/confirming/supplier
      const baseURI2 = '/api-confirming/confirming/supplier/debtors';
      let loader2 = this.$loading.show();
      this.$http.get(baseURI2)
            .then((result) => {
              //una vez termina de paginar, procedo a formatear datos para que se vean correctamente
              result.data.data.forEach(deudor => {
                    deudor.contractId = deudor.contractId.replace(/^0+/, '');
                    if(deudor.relatedAccount) {
                      deudor.relatedAccount = deudor.relatedAccount.formats[0].value;
                    }
                    this.deudores.push(deudor);
              });
            })
            .catch(error => {
              var codError = error.response.data.result.errors[0].errorCode;
              var descError = error.response.data.result.errors[0].errorDescription;
              ventana.mensajeError = codError + " - " + descError;
              ventana.confirmacion = "KO";
              window.scroll({
                top: 0,
                left: 0,
                behavior: 'smooth'
              });
            })
            .then(function () {
              loader2.hide();
            });
    },

    computed : {
      isDisabled: function() {
        return  !this.model.account;
      },
      isDeudorDisabled: function() {
        var retorno=true;
        for(var i=0; i < this.deudores.length; i++){
          if(this.deudores[i].relatedAccount!=null && this.deudores[i].relatedAccount!=""){
            retorno=false;
          }
        }
        return retorno;
      }
    },
    methods: {
      refresh(){ //esto tiene la funcion de refrescar el componente cuando volvemos a clickar sobre el en las NavigationBars
        this.$parent.keyRefresh+=1; //al cambiar la key de esta section que lo abarca todo, vue dispara un update
      },
      callBackAceptar(confirmacion, mensaje){
        this.beforeSubmit = false;
        this.confirmacion = confirmacion;
        this.mensajeError = mensaje;
        this.datosFirma = null;
      },
      callBackCancelar(){
         this.beforeSubmit = true;
         this.datosFirma = null;
      },
      aceptarCuentaUnica() {
        this.submitted = true;
        const ventana=this;
        const baseURI = '/api-confirming/confirming/suppliers';
        this.llamada = {
          urlEndpoint : baseURI,
          metodo : 'PUT'
        };
        this.params = {
          id : this.resultado.data.data.id,
          name : this.resultado.data.data.name,
          account : this.model.account
        };        
        let loader = this.$loading.show();
        this.$http.put(baseURI, this.params)
        .then(() => {
          this.beforeSubmit = false;
          ventana.confirmacion='OK';
          window.scroll({
            top: 0,
            left: 0,
            behavior: 'smooth'
          });
        })
        .catch(error => {
          if(error.response){ 
            if(error.response.status != 200) {
              if(error.response.data.result.errors[0].errorCode == "096H") {
                this.datosFirma = error.response.data.result.errors[0].info;
                this.beforeSubmit = false;
              } else {
                var codError = error.response.data.result.errors[0].errorCode;
                var descError = error.response.data.result.errors[0].errorDescription;
                this.mensajeError = codError + " - " + descError;
                this.confirmacion = "KO";
                window.scroll({
                  top: 0,
                  left: 0,
                  behavior: 'smooth'
                });
              }
            }
          }else{ //si no, por defecto
            ventana.mensajeError='Algo ha ido mal, asegúrate que has introducido correctamente los datos';
            ventana.confirmacion='KO';
          }
        })
        .then(function () {
          loader.hide();
        });
      },
      aceptarCuentasDeudores() {
        this.submitted = true;
        this.confirmacion = null;
        var ventana = this;
        const baseURI = '/api-confirming/confirming/supplier/debtors';
        let loader = this.$loading.show();
        var i = 0;
        this.llamadaRecursiva(ventana,baseURI,loader,i);
      },
      llamadaRecursiva (ventana,baseURI,loader,i) {
        this.llamada = {
          urlEndpoint : baseURI,
          metodo : 'PUT'
        };
        if(i < ventana.deudores.length) {
          if(this.deudores[i].relatedAccount==null && this.deudores[i].relatedAccount==""){//Si el numero de cuenta esta vacio, el deudor no se modifica, pasamos al siguiente.
            i++;
            this.llamadaRecursiva(ventana,baseURI,loader,i);
          }else{
            this.params = {
              contractId : this.deudores[i].contractId,
              name : this.deudores[i].name,
              automaticAdvance : this.deudores[i].automaticAdvance,
              relatedAccount : this.deudores[i].relatedAccount,
              userConditions : "1"
            };     
            const options={
              params : {
                'userConditions' : "1"
              }
            }   
            this.$http.put(baseURI, this.params, options)
            .then(() => {
              i++;
              this.llamadaRecursiva(ventana,baseURI,loader,i);
              ventana.confirmacion='OK';
            })
            .catch(error => {
              if(error.response){
                var codError = null; 
                var descError = null;
                if(error.response.status != 200) {
                  if(error.response.data.result.errors[0].errorCode == "096H") {
                    this.datosFirma = error.response.data.result.errors[0].info;
                    this.beforeSubmit = false;
                  } else if(error.response.data.result.errors[0].errorCode == "313I"){
                    i++;
                    this.llamadaRecursiva(ventana,baseURI,loader,i);
                    codError = error.response.data.result.errors[0].errorCode;
                    descError = error.response.data.result.errors[0].errorDescription;
                    this.mensajeError = codError + " - " + descError;
                  } else {
                    codError = error.response.data.result.errors[0].errorCode;
                    descError = error.response.data.result.errors[0].errorDescription;
                    this.mensajeError = codError + " - " + descError;
                    this.confirmacion = "KO";
                    loader.hide();
                    window.scroll({
                      top: 0,
                      left: 0,
                      behavior: 'smooth'
                    });
                  }
                }
              }else{ //si no, por defecto
                ventana.mensajeError='Algo ha ido mal, asegúrate que has introducido correctamente los datos';
                ventana.confirmacion='KO';
              }
            })
            .then(function () {
              if(i==ventana.deudores.length - 1) {
                if(ventana.confirmacion != 'OK'){
                  ventana.confirmacion = 'KO';
                } else {
                  ventana.beforeSubmit2 = false;
                }
                window.scroll({
                  top: 0,
                  left: 0,
                  behavior: 'smooth'
                }); 
                loader.hide();
              }
            })
          }
        }else{
          if(ventana.confirmacion != 'OK'){
            ventana.confirmacion = 'KO';
          } else {
            ventana.beforeSubmit2 = false;
          }
          window.scroll({
            top: 0,
            left: 0,
            behavior: 'smooth'
            }); 
          loader.hide();
        }
      }
    }
}
</script>